import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, BarChart, Bar, PieChart, Pie, Cell, Legend } from 'recharts';

const COLORS = ['#f97316', '#0ea5e9', '#22c55e', '#a855f7', '#ef4444', '#64748b'];
const DEVICE_LABELS = { mobile: 'Mobil', desktop: 'Masaüstü', tablet: 'Tablet' };

const Card = ({ title, children, testid }) => (
  <div className="rounded-2xl bg-white border border-gray-100 p-4" data-testid={testid}>
    <h3 className="font-bold text-gray-900 mb-3">{title}</h3>
    <div className="h-64">{children}</div>
  </div>
);

export const DailyChart = ({ data }) => (
  <Card title="Günlük kullanıcı ve oturum" testid="chart-daily">
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis dataKey="date" tick={{ fontSize: 11 }} tickFormatter={(d) => d.slice(5)} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="users" name="Kullanıcı" stroke="#f97316" strokeWidth={2} dot={false} />
        <Line type="monotone" dataKey="sessions" name="Oturum" stroke="#0ea5e9" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  </Card>
);

export const HourlyChart = ({ data, day, onDayChange }) => (
  <div className="rounded-2xl bg-white border border-gray-100 p-4" data-testid="chart-hourly">
    <div className="flex items-center justify-between mb-3 gap-2">
      <h3 className="font-bold text-gray-900">Saatlik trafik</h3>
      <input type="date" value={day} onChange={(e) => onDayChange(e.target.value)} className="border rounded-lg px-2 py-1 text-sm" data-testid="hourly-day-input" />
    </div>
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
          <XAxis dataKey="hour" tick={{ fontSize: 10 }} interval={2} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
          <Tooltip />
          <Bar dataKey="page_views" name="Görüntüleme" fill="#f97316" radius={[4, 4, 0, 0]} />
          <Bar dataKey="users" name="Kullanıcı" fill="#0ea5e9" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export const SourcesChart = ({ data }) => (
  <Card title="Trafik kaynakları (oturum)" testid="chart-sources">
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} layout="vertical" margin={{ left: 40 }}>
        <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11 }} />
        <YAxis type="category" dataKey="channel" tick={{ fontSize: 11 }} width={120} />
        <Tooltip />
        <Bar dataKey="sessions" name="Oturum" fill="#f97316" radius={[0, 4, 4, 0]} />
      </BarChart>
    </ResponsiveContainer>
  </Card>
);

export const DevicesChart = ({ data }) => (
  <Card title="Cihaz dağılımı" testid="chart-devices">
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie data={data.map(d => ({ ...d, name: DEVICE_LABELS[d.device] || d.device }))} dataKey="sessions" nameKey="name" outerRadius={90} label>
          {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  </Card>
);
